<template>
    <div class="wx-container wx-container-flex">
        <demand-search-bar :filters="filters" v-on:filter="search"></demand-search-bar>
        <div class="scroll-container scroll-container-tab">
            <div class="scroll-content" ref="list" v-scroll="'list'" v-infinite-scroll="more" infinite-scroll-disabled="searching">
                <div v-for="(item, index) in list" :key="item.id">
                    <demand-list-item :demand="item" v-on:receive="update(index)"></demand-list-item>
                </div>

                <div class="empty-notification" v-if="!searching && list.length <= 0">
                    <div class="empty-notification__text disable">暂无需求</div>
                </div>
            </div>
        </div>

        <search-panel :toggle="current_filtering === 0" v-on:cancel="cancel">
            <search-location :filters="filters" v-on:search="research"></search-location>
        </search-panel>

        <search-panel :toggle="current_filtering === 1" v-on:cancel="cancel">
            <search-budget :filters="filters" v-on:search="research"></search-budget>
        </search-panel>

        <search-panel :toggle="current_filtering === 2" v-on:cancel="cancel">
            <search-layout :filters="filters" v-on:search="research"></search-layout>
        </search-panel>
    </div>
</template>

<script>
    const infiniteScroll = window.infiniteScroll
    import token from '@/interface/utils/token'
    import { viewDemandList } from '@/interface/modules/requirement.api'
    import DemandSearchBar from '@/components/Requirement/search-bar'
    import SearchPanel from '@/components/Requirement/search-panel'
    import SearchLocation from '@/components/Requirement/search-location'
    import SearchBudget from '@/components/Requirement/search-budget'
    import SearchLayout from '@/components/Requirement/search-layout'
    import DemandListItem from '@/components/Requirement/list-item'

    export default {
        directives: { infiniteScroll },
        components: {
            DemandSearchBar,
            DemandListItem,
            SearchPanel,
            SearchLocation,
            SearchBudget,
            SearchLayout
        },
        data () {
            return {
                filters: {
                    region: '',
                    stations: '',
                    cost: '',
                    page: 0,
                    city: token.getToken('city') ? token.getToken('city') : '上海',
                    layout: ''
                },
                current_filtering: null,
                total: 1,
                list: [],
                searching: false,
                initializing: false
            }
        },
        methods: {
            more () {
                const that = this
                if (this.filters.page < this.total) {
                    this.searching = true
                    this.filters.page ++
                    viewDemandList({
                        data: this.filters,
                        success: res => {
                            that.searching = false
                            that.list = that.list.concat(res.items)
                            that.total = res.total_page
                        }
                    })
                }
            },
            search (e) {
                this.current_filtering = e.index
            },
            cancel () {
                this.current_filtering = null
            },
            research (e) {
                this.filters = {...this.filters, ...e}
                this.cancel()
                this.filters.page = 0
                this.list = []
                this.total = 1
                this.more()
            },
            update (i) {
                this.list[i].has_receive = true
            }
        },
        activated () {
            const that = this
            const scrollTop = token.getToken('list-position')
            if (scrollTop) this.$nextTick(() => {
                that.$refs.list.scrollTop = scrollTop
            })
        }
    }
</script>

